/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { components } from "react-select";
import { Check } from "lucide-react";
import { SelectValue } from "../../../interfaces";

export const CustomMultiValue = ({
  getValue,
  index,
  isDisabled,
  selectProps,
}: any) => {
  if (index !== 0) return null;
  if (selectProps.inputValue !== "") return null;

  const { allButtonLabel, inputValue, itemsSelectedLabel, options } =
    selectProps;
  const selectedValues = getValue();

  return (
    <span
      className={`text-sm font-normal ${
        inputValue === "" ? "max-w-[90%] truncate" : ""
      } ${isDisabled ? "text-gray-500" : "text-black"}`}
    >
      {selectedValues.length === 1
        ? selectedValues[0].label
        : selectedValues.length === options.length
          ? allButtonLabel
          : `${selectedValues.length} ${itemsSelectedLabel}`}
    </span>
  );
};

export const CustomMenuList = ({ selectProps, ...props }: any) => {
  const { onChange, value } = selectProps;
  const valueSafe = Array.isArray(value) ? value : [];

  const filteredOptions = React.Children.toArray(props.children)
    .map((child: any) => child?.props?.data)
    .filter(Boolean);

  const handleSelectAll = (): void => {
    const selectedValues: string[] = valueSafe.map((v: SelectValue) => v.value);
    const allFilteredSelected: boolean = filteredOptions.every(
      (opt: SelectValue) => selectedValues.includes(opt.value),
    );

    if (allFilteredSelected) {
      const newValues: SelectValue[] = valueSafe.filter(
        (v: SelectValue) =>
          !filteredOptions.some((opt: SelectValue) => opt.value === v.value),
      );
      onChange(newValues);
    } else {
      const newOptionsToAdd: SelectValue[] = filteredOptions.filter(
        (opt: SelectValue) => !selectedValues.includes(opt.value),
      );
      const newValues: SelectValue[] = [...valueSafe, ...newOptionsToAdd];
      onChange(newValues);
    }
  };

  return (
    <>
      {filteredOptions.length > 1 && (
        <div className="border-b border-gray-200 px-[5px] py-1">
          <button
            className={`flex w-full items-center justify-between rounded-md px-2 py-1.5 hover:bg-gray-100 ${
              valueSafe.length === filteredOptions.length
                ? "bg-gray-100"
                : "bg-white"
            }`}
            onClick={handleSelectAll}
            onTouchEnd={(e) => {
              handleSelectAll();
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            <span className="text-sm font-medium text-gray-900">
              {selectProps.allButtonLabel}
            </span>
            <div className="inline-flex w-5 items-center justify-center pt-0.5">
              {valueSafe.length === filteredOptions.length && (
                <Check className="h-4 w-4 shrink-0" />
              )}
            </div>
          </button>
        </div>
      )}
      <components.MenuList
        {...props}
        selectProps={selectProps}
      />
    </>
  );
};

export const CustomOption = (props: any) => (
  <components.Option {...props}>
    <div className="flex items-start gap-2">
      <span className={`flex-1 ${props.isDisabled ? "text-gray-400" : ""}`}>
        {props.label}
      </span>
      <div className="inline-flex w-5 items-center justify-center pt-0.5">
        {props.isSelected && <Check className="h-4 w-4 shrink-0" />}
      </div>
    </div>
  </components.Option>
);
